module.exports = __webpack_public_path__ + "img/pink.3f3bad22.svg";